export const buildRegexVariants = (candidate: string): RegExp[] => {
  if (!candidate) return [];
  const normalized = candidate.trim();
  if (!normalized) return [];
  const escaped = normalized.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const flexible = escaped.replace(/[_\-\s]+/g, '[-_\\s]*');
  return [
    new RegExp(`^${flexible}$`, 'i'),
    new RegExp(flexible, 'i')
  ];
};

export const findMatchingKey = (keys: string[], candidates: string[]): string | null => {
  if (!keys.length || !candidates.length) return null;
  const regexes = candidates.flatMap(buildRegexVariants);
  if (!regexes.length) return null;
  const match = keys.find((key) => regexes.some((regex) => regex.test(key)));
  return match ?? null;
};
